import { render, staticRenderFns } from "./CompanyIndex.vue?vue&type=template&id=513c7f7b&scoped=true&"
import script from "./CompanyIndex.vue?vue&type=script&lang=js&"
export * from "./CompanyIndex.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIndex.vue?vue&type=style&index=0&id=513c7f7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c7f7b",
  null
  
)

export default component.exports